import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '../../store';
import { updateUserActivationStatus, clearUser } from '../../userSlice';
import { clearAllChats } from '../../chatSlice';
import { getMe } from '../utils/chatUtils';

export const useActivationCheck = () => {
  const dispatch: AppDispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user);
  const [isChecking, setIsChecking] = useState(false);
  const [isActivationPending, setIsActivationPending] = useState(false);

  const checkActivationStatus = async () => {
    if (!user) return;

    setIsChecking(true);
    try {
      const profile = await getMe();

      if (profile) {
        // Обновляем статус активации в Redux
        dispatch(updateUserActivationStatus({ is_active: profile.is_active }));

        if (profile.is_active !== true) {
          setIsActivationPending(true);
        } else {
          setIsActivationPending(false);
        }
      }
    } catch (error) {
      // Если ошибка авторизации, очищаем пользователя и кеш чатов
      dispatch(clearUser());
      dispatch(clearAllChats());
      setIsActivationPending(false);
    } finally {
      setIsChecking(false);
    }
  };

  // Проверяем статус при каждом изменении пользователя
  useEffect(() => {
    if (user) {
      if (user.is_active !== true) {
        setIsActivationPending(true);
      } else {
        checkActivationStatus();
      }
    } else {
      // Если пользователя нет, скрываем страницу ожидания
      setIsActivationPending(false);
    }
  }, [user?.id]); // Проверяем при изменении ID пользователя

  // Проверяем статус при загрузке компонента
  useEffect(() => {
    if (user) {
      checkActivationStatus();
    }
  }, []);

  return {
    isChecking,
    isActivationPending,
    checkActivationStatus
  };
};
